import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mcep9tfvn8: FaireBrandEntity = {
  token: "b_mcep9tfvn8",
  type: "brand",
  name: "Eastanbul",
  avatarUrl:
    "https://cdn.faire.com/fastly/c119c14cad65cfd7eac252c31535402ae6836b0ab4bf821fd5338eae9ac62f76.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/aca0808d293c3ac0c798f40d2721be7b98fcb02f0e1a0a1d71808c5de7a64775.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c119c14cad65cfd7eac252c31535402ae6836b0ab4bf821fd5338eae9ac62f76.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aca0808d293c3ac0c798f40d2721be7b98fcb02f0e1a0a1d71808c5de7a64775.jpeg",
  location: "Carrollton, TX, USA",
  minimumOrderDollars: 139,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Our journey began in 2017 as a modest importer of Turkish Delight. Driven by a passion for authentic, high-quality ingredients, we have since expanded our offerings to celebrate the rich culinary traditions of Turkish, Mediterranean, and Middle Eastern cuisine. Our mission is to bring the vibrant flavors and heritage of these regions to kitchens around the world. Whether you're preparing a savory dish, crafting a sweet dessert, or enjoying a simple snack, we strive to make every bite a memorable experience.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:44.162Z",
    importedBy: "entity-db-cli",
  },
};
